import typia from 'typia'

import { type MultiLayersPreviewCollageDisplayCardContent } from '@/components/DisplayCards/DisplayCard'
import { ArtworkType, DesignGroupType } from '@/graphql/creator-platform/generated'

export function currentHashType(hash: string): ArtworkType | DesignGroupType | undefined {
  const value = hash.replace(/^#/, '')
  if (Object.values(ArtworkType).includes(value as ArtworkType)) {
    return value as ArtworkType
  }
  if (Object.values(DesignGroupType).includes(value as DesignGroupType)) {
    return value as DesignGroupType
  }
  return undefined
}
export function isInDesignGroupType(value: string): value is DesignGroupType {
  return value in DesignGroupType
}
export function isInArtworkType(value: string): value is ArtworkType {
  return value in ArtworkType
}
export const isMultiLayersPreviewCollageDisplayCardContent =
  typia.createIs<MultiLayersPreviewCollageDisplayCardContent>()
